import React, { Component, createRef } from 'react';
import {
	AdvancedMarker,
	InfoWindow,
	Pin
} from '@vis.gl/react-google-maps';
import RoleUtils from '../../utils/RoleUtils';
import { getUserNeighbourhoodName } from '../../firebase/firebase';

class NewNoteMarker extends Component {
	constructor(props) {
		super(props);
		this.markerRef = createRef();
	}
	state = {
		descriptionError: '',
		description: '',
		scheduled_delete_at: '',
		isForTeams: false
	}

	onSubmit = event => {
		event.preventDefault();
		this.clearDescriptionError();

		const { description, scheduled_delete_at, isForTeams } = this.state;
		if (description === '') {
			this.setState({ descriptionError: 'Voer een omschrijving in.' });
			return;
		}

		if (scheduled_delete_at === '') {
			this.setState({ descriptionError: 'Voer een einddatum in.' });
			return;
		}

		this.props.onSubmit(description, scheduled_delete_at, isForTeams);
		this.setState({ description: '' });
	}

	onChangeDescription = event => {
		this.setState({ description: event.target.value });
	}

	onChangeScheduladDeleteAt = event => {
		this.setState({ scheduled_delete_at: event.target.value });
	}

	onChangeisForTeams = event => {
		this.setState({ isForTeams: event.target.checked });
	}

	clearDescriptionError = () => {
		this.setState({ descriptionError: '' });
	}

	render() {
		const { props, state } = this;
		let userData = this.props.rootUserData;

		return (
			<AdvancedMarker
				ref={this.markerRef}
				position={props.newNote.position}
				onClick={props.onClick}
			>
				<Pin />

				<InfoWindow anchor={this.markerRef.current} onCloseClick={props.onCloseClick}>
					<form onSubmit={this.onSubmit}>
						<h3 style={{ marginBottom: 0 }}>Hotspot aanmaken</h3>
						{this.props.newNote.address && <span><strong>Adres:</strong> {this.props.newNote.address}</span>}

						<div className="form-group" style={{ marginTop: 12 }}>
							<label htmlFor="description">Omschrijving</label>
							<input
								type="text"
								id="description"
								name="description"
								className={`form-control ${state.descriptionError !== '' ? ' is-invalid' : ''}`}
								placeholder="Omschrijving..."
								value={state.description}
								onChange={this.onChangeDescription}
							/>
							<label htmlFor="scheduled_delete_at" style={{ marginTop: 6 }}>Automatisch verwijderen op</label>
							<input
								type="date"
								id="scheduled_delete_at"
								name="scheduled_delete_at"
								className="form-control"
								value={state.scheduled_delete_at}
								onChange={this.onChangeScheduladDeleteAt}
							/>

							{(RoleUtils.hasRole(userData, RoleUtils.Roles.Politie) || RoleUtils.hasRole(userData, RoleUtils.Roles.Gemeente) || RoleUtils.hasRole(userData, RoleUtils.Roles.Administrator)) && (
								<div className="form-group" style={{ marginTop: 12 }}>
									<label htmlFor="isForTeams">Delen met:</label>
									<br />
									<input
										autoFocus={false}
										type="checkbox"
										id="isForTeams"
										name="isForTeams"
										checked={state.isForTeams}
										onChange={this.onChangeisForTeams}
										style={{marginRight: 6 }}
									/>
									<span style={{fontWeight: 500}}>Andere buurtpreventieteams in {this.props.newNote.address.split(' ').pop()}</span>
								</div>
							)}
							<div className="invalid-feedback">
								{state.descriptionError}
							</div>
						</div>
						<button
							type="submit"
							className="btn btn-outline-primary"
						>
							Aanmaken
						</button>
						<button
							className="btn btn-danger"
							onClick={props.onCloseClick}
						>
							Annuleren
						</button>
					</form>
				</InfoWindow>

			</AdvancedMarker>
		)
	}
}

export default NewNoteMarker;
